import Header from "../../Components/Header/index"
import HomeContent from "../../Components/HomeContent"
// import Gif from "../../Components/gif"


function HomePage() {
    return (
        <main className="main">
            <Header />
            <HomeContent/>
        </main>

    )
}

export default HomePage